import { Component, OnInit } from '@angular/core';
import {ApiRestService} from "../_services/api-rest.service";
import {Smtp} from "../_models/smtp";
import {SmtpEditComponent} from "../smtp-edit/smtp-edit.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-smtp-list',
  templateUrl: './smtp-list.component.html'
})
export class SmtpListComponent implements OnInit {
  List: Smtp[] = [];
  constructor(
    private apiRestService: ApiRestService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.apiRestService.ListSmtp({page:0, size:10}).subscribe(data => this.List = data.data);
  }
  edit(value?: Smtp){
    const editmodal = this.modalService.open(SmtpEditComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<SmtpEditComponent>editmodal.componentInstance).item = value ?? new Smtp();
  }

}
